import { render, staticRenderFns } from "./CreateApiKey.vue?vue&type=template&id=5c33711e&scoped=true&"
import script from "./CreateApiKey.vue?vue&type=script&lang=ts&"
export * from "./CreateApiKey.vue?vue&type=script&lang=ts&"
import style0 from "./CreateApiKey.vue?vue&type=style&index=0&id=5c33711e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c33711e",
  null
  
)

export default component.exports